export enum TipoOpcaoEnum {
  Entrada = 0,
  RespostaQuestionario = 1,
  Servico = 2,
  Sitab = 3
}
